export const DiccionarioCajas_ES = [
    {
        'codigo': 'ErrorActualizarBecado',
        'mensaje': 'Se presentaron problemas al actualizar los datos de la beca del estudiante.'
    },
    {
        'codigo': 'ErrorActualizarCajBeca',
        'mensaje': 'Se presentaron problemas al actualizar los datos de la beca.'
    },
    {
        'codigo': 'ErrorActualizarCajBecado',
        'mensaje': 'Se presentaron problemas al actualizar los datos de la beca del estudiante.'
    },
    {
        'codigo': 'ErrorActualizarCajBecaSedes',
        'mensaje': 'Se presentaron problemas al actualizar las sedes de las becas.'
    },
    {
        'codigo': 'ErrorActualizarCajConcepto',
        'mensaje': 'Se presentaron problemas al actualizar los datos del concepto.'
    },
    {
        'codigo': 'ErrorActualizarCajConceptoMatricula',
        'mensaje': 'Se presentaron problemas al actualizar las monedas y costos del concepto.'
    },
    {
        'codigo': 'ErrorActualizarCajImpuesto',
        'mensaje': 'Se presentaron problemas al actualizar los datos del impuesto.'
    },
    {
        'codigo': 'ErrorActualizarConcepto',
        'mensaje': 'Se presentaron problemas al actualizar los datos del concepto.'
    },
    {
        'codigo': 'ErrorActualizarConceptoImpuesto',
        'mensaje': 'Se presentaron problemas al actualizar los impuestos del concepto.'
    },
    {
        'codigo': 'ErrorActualizarConceptoMoneda',
        'mensaje': 'Se presentaron problemas al actualizar las monedas y costos del concepto.'
    },
    {
        'codigo': 'ErrorActualizarFacturaPendiente',
        'mensaje': 'Se presentaron problemas al actualizar los datos de facturación.'
    },
    {
        'codigo': 'ErrorActualizarPayMethod',
        'mensaje': 'Se presentaron problemas al actualizar los datos de métodos de pago.'
    },
    {
        'codigo': 'ErrorActualizarProforma',
        'mensaje': 'Se presentaron problemas al actualizar la factura proforma.'
    },
    {
        'codigo': 'ErrorActualizarTransaccionImpuesto',
        'mensaje': 'Se presentaron problemas al actualizar los impuestos del concepto.'
    },
    {
        'codigo': 'ErrorAgregarExoneracion',
        'mensaje': 'Se presentaron problemas al agregar los datos de exoneración de pago.'
    },
    {
        'codigo': 'ErrorAgregarExoneracionBD',
        'mensaje': 'Se presentaron problemas al agregar los datos de exoneración de pago.'
    },
    {
        'codigo': 'ErrorAmountNotEmty',
        'mensaje': 'Debe ingresar un monto.'
    },
    {
        'codigo': 'ErrorAnularFactura',
        'mensaje': 'Se presentaron problemas al anular la facturación.'
    },
    {
        'codigo': 'ErrorBecadoObtenerBecaporId',
        'mensaje': 'Se presentaron problemas al obtener los datos de la beca.'
    },
    {
        'codigo': 'ErrorCajBecadoListaBecaPorSede',
        'mensaje': 'Se presentaron problemas al obtener las sedes de la beca.'
    },
    {
        'codigo': 'ErrorCampusIdNotEmpty',
        'mensaje': 'Debe seleccionar una sede.'
    },
    {
        'codigo': 'ErrorCampusIdNotEmty',
        'mensaje': 'Debe seleccionar una sede.'
    },
    {
        'codigo': 'ErrorCampusNotEmty',
        'mensaje': 'Debe seleccionar una sede.'
    },
    {
        'codigo': 'ErrorCargarFacturaPago',
        'mensaje': 'Se presentaron problemas al cargar los datos de la facturación.'
    },
    {
        'codigo': 'ErrorCashierIdNotEmpty',
        'mensaje': 'Debe seleccionar el cajero.'
    },
    {
        'codigo': 'ErrorCashRegisterIdNotEmpty',
        'mensaje': 'No se encontraron los datos de la facturación.'
    },
    {
        'codigo': 'ErrorCerrarCaja',
        'mensaje': 'Se presentaron problemas al realizar el cierre de cajas.'
    },
    {
        'codigo': 'ErrorCerrarCajaBD',
        'mensaje': 'Se presentaron problemas al realizar el cierre de cajas.'
    },
    {
        'codigo': 'ErrorClosingDateNotEmpty',
        'mensaje': 'Debe seleccionar una fecha de cierre.'
    },
    {
        'codigo': 'ErrorCodeNotEmty',
        'mensaje': 'El código es requerido.'
    },
    {
        'codigo': 'ErrorCompanyIdNotEmty',
        'mensaje': 'No se encontraron los datos de la compañía.'
    },
    {
        'codigo': 'ErrorCuadreCajero',
        'mensaje': 'Se presentaron problemas al registrar el balance de facturación.'
    },
    {
        'codigo': 'ErrorCuadreCajeroBD',
        'mensaje': 'Se presentaron problemas al registrar el balance de facturación.'
    },
    {
        'codigo': 'ErrorCurrencyIdNotEmty',
        'mensaje': 'Debe seleccionar una moneda.'
    },
    {
        'codigo': 'ErrorCustomerNotEmty',
        'mensaje': 'Debe seleccionar un CIF.'
    },
    {
        'codigo': 'ErrorDeleteBeca',
        'mensaje': 'Se presentaron problemas al eliminar la beca.'
    },
    {
        'codigo': 'ErrorDeleteCajCashier',
        'mensaje': 'Se presentaron problemas al eliminar el cajero.'
    },
    {
        'codigo': 'ErrorDeleteCajProforms',
        'mensaje': 'Se presentaron problemas al eliminar la factura proforma.'
    },
    {
        'codigo': 'ErrorDeleteFacturaDetalle',
        'mensaje': 'Se presentaron problemas al eliminar el detalle de la factura.'
    },
    {
        'codigo': 'ErrorDeletePayMethod',
        'mensaje': 'Se presentaron problemas al eliminar el método de pago.'
    },
    {
        'codigo': 'ErrorDscNotEmty',
        'mensaje': 'Debe ingresar una descripción.'
    },
    {
        'codigo': 'ErrorEliminarBeca',
        'mensaje': 'Se presentaron problemas al eliminar la beca.'
    },
    {
        'codigo': 'ErrorEliminarCajBeca',
        'mensaje': 'Se presentaron problemas al eliminar la beca.'
    },
    {
        'codigo': 'ErrorEliminarCajBecado',
        'mensaje': 'Se presentaron problemas al eliminar la beca del estudiante.'
    },
    {
        'codigo': 'ErrorEliminarCajConceptoMatricula',
        'mensaje': 'Se presentaron problemas al eliminar los costos del concepto.'
    },
    {
        'codigo': 'ErrorEliminarCajConceptos',
        'mensaje': 'Se presentaron problemas al eliminar el concepto.'
    },
    {
        'codigo': 'ErrorEliminarConcepto',
        'mensaje': 'Se presentaron problemas al eliminar el concepto.'
    },
    {
        'codigo': 'ErrorEliminarConceptoMoneda',
        'mensaje': 'Se presentaron problemas al eliminar los costos del concepto.'
    },
    {
        'codigo': 'ErrorEliminarExoneracion',
        'mensaje': 'Se presentaron problemas al eliminar la exoneración de pago.'
    },
    {
        'codigo': 'ErrorEliminarExoneracionBD',
        'mensaje': 'Se presentaron problemas al eliminar la exoneración de pago.'
    },
    {
        'codigo': 'ErrorEliminarFacturaPagoDetalle',
        'mensaje': 'Se presentaron problemas al eliminar el detalle de pago.'
    },
    {
        'codigo': 'ErrorEliminarImpuesto',
        'mensaje': 'Se presentaron problemas al eliminar el impuesto.'
    },
    {
        'codigo': 'ErrorEliminarPayMethod',
        'mensaje': 'Se presentaron problemas al eliminar el método de pago.'
    },
    {
        'codigo': 'ErrorEliminarProforma',
        'mensaje': 'Se presentaron problemas al eliminar la factura proforma.'
    },
    {
        'codigo': 'ErrorEmailNotEmty',
        'mensaje': 'Debe ingresar un correo electrónico.'
    },
    {
        'codigo': 'ErrorExceptionIdNotEmpty',
        'mensaje': 'No se encontraron los datos de la exoneración de pago.'
    },
    {
        'codigo': 'ErrorExistsCajCashier',
        'mensaje': 'Ya existe un cajero para el usuario seleccionado.'
    },
    {
        'codigo': 'ErrorExistsConceptoCode',
        'mensaje': 'Ya existe un concepto con el código ingresado.'
    },
    {
        'codigo': 'ErrorExpirationNotEmty',
        'mensaje': 'Debe ingresar la fecha de vencimiento.'
    },
    {
        'codigo': 'ErrorFacturasPendientesExon',
        'mensaje': 'Se presentaron problemas al obtener la facturación pendiente.'
    },
    {
        'codigo': 'ErrorFechaCierreCaja',
        'mensaje': 'Debe ingresar la fecha para el proceso de cierre de cajas.'
    },
    {
        'codigo': 'ErrorGenerarFactura',
        'mensaje': 'Se presentaron problemas al generar los datos de facturación.'
    },
    {
        'codigo': 'ErrorIdeNotEmty',
        'mensaje': 'Debe ingresar el número de identificación.'
    },
    {
        'codigo': 'ErrorIdNotEmpty',
        'mensaje': 'Se presentaron problemas al obtener los datos para realizar la acción solicitada.'
    },
    {
        'codigo': 'ErrorInsertarBecado',
        'mensaje': 'Se presentaron problemas al registrar los datos de la beca del estudiante.'
    },
    {
        'codigo': 'ErrorInsertarConcepto',
        'mensaje': 'Se presentaron problemas al registrar el concepto.'
    },
    {
        'codigo': 'ErrorInsertarConceptoMoneda',
        'mensaje': 'Se presentaron problemas al registrar los costos del concepto.'
    },
    {
        'codigo': 'ErrorInsertarFacturaConcepto',
        'mensaje': 'Se presentaron problemas al registrar el concepto a la facturación.'
    },
    {
        'codigo': 'ErrorInsertarFacturaCuota',
        'mensaje': 'Se presentaron problemas al registrar la mensualidad de financiamiento.'
    },
    {
        'codigo': 'ErrorInsertarImpuesto',
        'mensaje': 'Se presentaron problemas al registrar el impuesto.'
    },
    {
        'codigo': 'ErrorInsertarProforma',
        'mensaje': 'Se presentaron problemas al registrar la factura proforma.'
    },
    {
        'codigo': 'ErrorInsertCajBeca',
        'mensaje': 'Se presentaron problemas al registrar la beca.'
    },
    {
        'codigo': 'ErrorInsertCajBecado',
        'mensaje': 'Se presentaron problemas al registrar los datos de la beca del estudiante.'
    },
    {
        'codigo': 'ErrorInsertCajCashier',
        'mensaje': 'Se presentaron problemas al registrar los datos del cajero.'
    },
    {
        'codigo': 'ErrorInsertCajConceptoMoneda',
        'mensaje': 'Se presentaron problemas al registrar los costos del concepto.'
    },
    {
        'codigo': 'ErrorInsertCajConceptos',
        'mensaje': 'Se presentaron problemas al registrar el concepto.'
    },
    {
        'codigo': 'ErrorInsertCajImpuesto',
        'mensaje': 'Se presentaron problemas al registrar el impuesto.'
    },
    {
        'codigo': 'ErrorInsertCajProforms',
        'mensaje': 'Se presentaron problemas al registrar la factura proforma.'
    },
    {
        'codigo': 'ErrorInsertCashier',
        'mensaje': 'Se presentaron problemas al registrar los datos del cajero.'
    },
    {
        'codigo': 'ErrorInsertFacturaPago',
        'mensaje': 'Se presentaron problemas al registrar los datos de pago de facturación.'
    },
    {
        'codigo': 'ErrorInsertPayMethod',
        'mensaje': 'Se presentaron problemas al registrar el método de pago.'
    },
    {
        'codigo': 'ErrorInvoiceIdNotEmpty',
        'mensaje': 'No se encontraron los datos de la facturación.'
    },
    {
        'codigo': 'ErrorInvoiceIdNotEmty',
        'mensaje': 'No se encontraron los datos de la facturación.'
    },
    {
        'codigo': 'ErrorLimpiarFactura',
        'mensaje': 'Se presentaron problemas al limpiar la facturación.'
    },
    {
        'codigo': 'ErrorListadoCajas',
        'mensaje': 'Se presentaron problemas al obtener los registros de facturación.'
    },
    {
        'codigo': 'ErrorListadoRegistroExon',
        'mensaje': 'Se presentaron problemas al obtener los registros exoneración de pago.'
    },
    {
        'codigo': 'ErrorListarFacturaFormaPago',
        'mensaje': 'Se presentaron problemas al obtener las formas de pago de la facturación.'
    },
    {
        'codigo': 'ErrorListCajBeca',
        'mensaje': 'Se presentaron problemas al obtener los registros de becas.'
    },
    {
        'codigo': 'ErrorListCajBecado',
        'mensaje': 'Se presentaron problemas al obtener los registros de becados.'
    },
    {
        'codigo': 'ErrorListCajBecadoListaBecaAsig',
        'mensaje': 'Se presentaron problemas al obtener los registros de becas.'
    },
    {
        'codigo': 'ErrorListCajBecaSedes',
        'mensaje': 'Se presentaron problemas al obtener las sedes de becas.'
    },
    {
        'codigo': 'ErrorListCajConceptoMoneda',
        'mensaje': 'Se presentaron problemas al obtener los costos de conceptos.'
    },
    {
        'codigo': 'ErrorListCajConceptos',
        'mensaje': 'Se presentaron problemas al obtener registros de conceptos.'
    },
    {
        'codigo': 'ErrorListCajImpuestos',
        'mensaje': 'Se presentaron problemas al obtener registros de impuestos.'
    },
    {
        'codigo': 'ErrorListCajProforms',
        'mensaje': 'Se presentaron problemas al obtener registros de facturas proformas.'
    },
    {
        'codigo': 'ErrorListFacturaConcepto',
        'mensaje': 'Se presentaron problemas al listar los conceptos de facturación.'
    },
    {
        'codigo': 'ErrorListFacturaCuota',
        'mensaje': 'Se presentaron problemas al listar las mensualidades de financiamiento.'
    },
    {
        'codigo': 'ErrorListFacturaCuotaFinanciamientos',
        'mensaje': 'Se presentaron problemas al listar las mensualidades de financiamiento.'
    },
    {
        'codigo': 'ErrorListFacturaDetalle',
        'mensaje': 'Se presentaron problemas al listar los registros de la facturación.'
    },
    {
        'codigo': 'ErrorListFacturaPendiente',
        'mensaje': 'Se presentaron problemas al listar los registros de facturación pendiente.'
    },
    {
        'codigo': 'ErrorListjCashier',
        'mensaje': 'Se presentaron problemas al obtener la lista de cajeros.'
    },
    {
        'codigo': 'ErrorListjPayMethods',
        'mensaje': 'Se presentaron problemas al obtener la lista de métodos de pago.'
    },
    {
        'codigo': 'ErrorListPayMethodCurrency',
        'mensaje': 'Se presentaron problemas al obtener la lista de métodos de pago.'
    },
    {
        'codigo': 'ErrorNameNotEmty',
        'mensaje': 'Debe ingresar el nombre.'
    },
    {
        'codigo': 'ErrorObtenerBecado',
        'mensaje': 'Se presentaron problemas al obtener los datos de la beca del estudiante.'
    },
    {
        'codigo': 'ErrorObtenerFactura',
        'mensaje': 'Se presentaron problemas al obtener los datos de la facturación.'
    },
    {
        'codigo': 'ErrorObtenerIdCajBeca',
        'mensaje': 'Se presentaron problemas al obtener los datos de la beca.'
    },
    {
        'codigo': 'ErrorObtenerIdCajBecado',
        'mensaje': 'Se presentaron problemas al obtener los datos de la beca del estudiante.'
    },
    {
        'codigo': 'ErrorObtenerIdProformaFactura',
        'mensaje': 'Se presentaron problemas al obtener los datos de la factura proforma.'
    },
    {
        'codigo': 'ErrorPagarFacturaPago',
        'mensaje': 'Se presentaron problemas al realizar el pago de la factura.'
    },
    {
        'codigo': 'ErrorPaymentMethodIdNotEmty',
        'mensaje': 'Se presentaron problemas al obtener los datos del método de pago.'
    },
    {
        'codigo': 'ErrorPayMethodIdNotEmpty',
        'mensaje': 'Se presentaron problemas al obtener los datos del método de pago.'
    },
    {
        'codigo': 'ErrorPctInscriptionNotEmty',
        'mensaje': 'Debe ingresar un porcentaje de beca para la matrícula.'
    },
    {
        'codigo': 'ErrorPctTuitionNotEmty',
        'mensaje': 'Debe ingresar un porcentaje de beca para la colegiatura.'
    },
    {
        'codigo': 'ErrorPctBecaNotEmty',
        'mensaje': 'Debe ingresar al menos un porcentaje de beca (Colegiatura o Matrícula).'
    },
    {
        'codigo': 'ErrorPctNotEmty',
        'mensaje': 'Debe ingresar el porcentaje del impuesto.'
    },
    {
        'codigo': 'ErrorPendingInvoiceIdNotEmpty',
        'mensaje': 'Se presentaron problemas al obtener los datos de la facturación pendiente.'
    },
    {
        'codigo': 'ErrorProformIdNotEmpty',
        'mensaje': 'Se presentaron problemas al obtener los datos de la factura proforma.'
    },
    {
        'codigo': 'ErrorRegistrosCajas',
        'mensaje': 'Se presentaron problemas al obtener los registros de facturación.'
    },
    {
        'codigo': 'ErrorSaveBeca',
        'mensaje': 'Se presentaron problemas al guardar la beca.'
    },
    {
        'codigo': 'ErrorScholarShipIdNotEmpty',
        'mensaje': 'Se presentaron problemas al obtener los datos de la beca.'
    },
    {
        'codigo': 'ErrorScholarShipNotEmty',
        'mensaje': 'Se presentaron problemas al obtener los datos de la beca.'
    },
    {
        'codigo': 'ErrorTaxIdNotEmpty',
        'mensaje': 'Se presentaron problemas al obtener los datos del impuesto.'
    },
    {
        'codigo': 'ErrorTransactionIdNotEmpty',
        'mensaje': 'Se presentaron problemas al obtener los datos del concepto.'
    },
    {
        'codigo': 'ErrorTransactionIdNotEmty',
        'mensaje': 'Se presentaron problemas al obtener los datos del concepto.'
    },
    {
        'codigo': 'ErrorTypeIdeNotEmty',
        'mensaje': 'Debe seleccionar un tipo de identificación.'
    },
    {
        'codigo': 'ErrorUpdateBeca',
        'mensaje': 'Se presentaron problemas al actualizar la beca.'
    },
    {
        'codigo': 'ErrorUpdateCajCashier',
        'mensaje': 'Se presentaron problemas al actualizar los datos del cajero.'
    },
    {
        'codigo': 'ErrorUpdateCajPayMethod',
        'mensaje': 'Se presentaron problemas al actualizar la forma de pago.'
    },
    {
        'codigo': 'ErrorUpdateCajProforms',
        'mensaje': 'Se presentaron problemas al actualizar la factura proforma.'
    },
    {
        'codigo': 'ErrorUpdateFacturaConcepto',
        'mensaje': 'Se presentaron problemas al actualizar el concepto de facturación.'
    },
    {
        'codigo': 'ErrorUpdateFacturaPendiente',
        'mensaje': 'Se presentaron problemas al actualizar la factura pendiente.'
    },
    {
        'codigo': 'ErrorUpdateSedes',
        'mensaje': 'Se presentaron problemas al actualizar las sedes.'
    },
    {
        'codigo': 'ErrorUserIdNotEmty',
        'mensaje': 'Debe seleccionar un usuario.'
    },
    {
        'codigo': 'ErrorUsuarioIdNotEmty',
        'mensaje': 'Debe seleccionar un usuario.'
    },
    {
        'codigo': 'ErrorValidarCajeroBD',
        'mensaje': 'Se presentaron problemas al validar los datos del cajero.'
    },
    {
        'codigo': 'ErrorValidarDetalleFacturaPago',
        'mensaje': 'Se presentaron problemas al validar el detalle de pago.'
    },
    {
        'codigo': 'ErrorValidarFacturaPago',
        'mensaje': 'Se presentaron problemas al validar el pago de la factura.'
    },
    {
        'codigo': 'ErrorValidarPagoFacturaPago',
        'mensaje': 'Se presentaron problemas al validar el pago de la factura.'
    },
    {
        'codigo': 'ErrorValidatingCode',
        'mensaje': 'Se presentaron problemas al validar el código ingresado.'
    },
    {
        'codigo': 'ErrorListConceptosGestiones',
        'mensaje': 'Se presentaron problemas al obtener la lista de transacciones.'
    },
    {
        'codigo': 'ErrorRegenerarFactura',
        'mensaje': 'Se presentaron problemas al procesar los registros de facturación.'
    },
    {
        'codigo': 'ErrorActualizaFinanciamiento',
        'mensaje': 'Se presentaron problemas al actualizar el financiamiento.'
    },
    {
        'codigo': 'ErrorListaItemPendiente',
        'mensaje': 'Se presentaron problemas al obtener la facturación pendiente.'
    },
    {
        'codigo': 'FormartFileError',
        'mensaje': 'Formato de archivo (extensión) no permitido.'
    },
    {
        'codigo': 'CodeRequeridoReference',
        'mensaje': 'La referencia es requerida.'
    },
    {
        'codigo': 'CodeRequeridoDetail',
        'mensaje': 'Debe indicar el detalle del pago.'
    },
    {
        'codigo': 'SearchOneFilterReq',
        'mensaje': 'Debe ingresar al menos un filtro de búsqueda.'
    },
    {
        'codigo': 'ErrorPayAmount',
        'mensaje': 'El monto recibido es inferior al monto a pagar.'
    },
    {
        'codigo': 'CodeRequeridoScholarShipId',
        'mensaje': 'El tipo de beca es requerida.'
    },
    {
        'codigo': 'CodeRequeridoPctInscription',
        'mensaje': 'El porcentaje de beca es requerido.'
    },
    {
        'codigo': 'CodeRequeridoPctTuition',
        'mensaje': 'El porcentaje de beca es requerido.'
    },
    {
        'codigo': 'CodeRequeridoAmount',
        'mensaje': 'El monto es requerido.'
    },
    {
        'codigo': 'CodeRequeridoCurrencyId',
        'mensaje': 'La moneda es requerida.'
    },
    {
        'codigo': 'CodeRequeridoInvoiceId',
        'mensaje': 'No se encontraron los datos de la facturación.'
    },
    {
        'codigo': 'CodeRequeridoCampusId',
        'mensaje': 'La sede es requerida.'
    },
    {
        'codigo': 'CodeRequeridoComentario',
        'mensaje': 'Debe ingresar un comentario.'
    },
    {
        'codigo': 'CodeRequeridoExectionId',
        'mensaje': 'No se encontraron los datos de la exoneración de pago.'
    },
    {
        'codigo': 'CodeRequeridoProcesoId',
        'mensaje': 'Debe seleccionar una sección de la lista.'
    },
    {
        'codigo': 'CodeRequeridoScholarShipId',
        'mensaje': 'No se encuentra el descuento seleccionado.'
    },
    {
        'codigo': 'CodeRequeridoPeriodDetailId',
        'mensaje': 'No se encuentra el periodo seleccionado.'
    },
    {
        'codigo': 'CodeRequeridoPeriodTypeId',
        'mensaje': 'No se encuentra el tipo de período seleccionado.'
    },
    {
        'codigo': 'ErrorUpdateFacturaCuotaSequence',
        'mensaje': 'Las cuotas de financiamiento deben agregarse en orden ascendente.'
    },
    {
        'codigo': 'ErrorDeleteFacturaCuotaSequence',
        'mensaje': 'Las cuotas de financiamiento deben eliminarse en orden descendente.'
    },
    {
        'codigo': 'ErrorUpdateFacturaCuota',
        'mensaje': 'Se presentaron problemas al registrar las cuotas de financiamiento.'
    },
    {
        'codigo': 'AmountHigherNoteFinan',
        'mensaje': 'Al realizar el pago del financiamiento se excede el monto pendiente.'
    },
    {
        'codigo': 'ErrorFinanInsertNote',
        'mensaje': 'Se presentaron problemas al aplicar las notas de financiamiento para la facturación.'
    },
];

